import _slicedToArray from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "google/protobuf/wrappers.proto" (package "google.protobuf", syntax proto3)
// tslint:disable
//
// Protocol Buffers - Google's data interchange format
// Copyright 2008 Google Inc.  All rights reserved.
// https://developers.google.com/protocol-buffers/
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are
// met:
//
//     * Redistributions of source code must retain the above copyright
// notice, this list of conditions and the following disclaimer.
//     * Redistributions in binary form must reproduce the above
// copyright notice, this list of conditions and the following disclaimer
// in the documentation and/or other materials provided with the
// distribution.
//     * Neither the name of Google Inc. nor the names of its
// contributors may be used to endorse or promote products derived from
// this software without specific prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
//
//
// Wrappers for primitive (non-message) types. These types are useful
// for embedding primitives in the `google.protobuf.Any` type and for places
// where we need to distinguish between the absence of a primitive
// typed field and its default value.
//
// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "google/protobuf/wrappers.proto" (package "google.protobuf", syntax proto3)
// tslint:disable
//
// Protocol Buffers - Google's data interchange format
// Copyright 2008 Google Inc.  All rights reserved.
// https://developers.google.com/protocol-buffers/
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are
// met:
//
//     * Redistributions of source code must retain the above copyright
// notice, this list of conditions and the following disclaimer.
//     * Redistributions in binary form must reproduce the above
// copyright notice, this list of conditions and the following disclaimer
// in the documentation and/or other materials provided with the
// distribution.
//     * Neither the name of Google Inc. nor the names of its
// contributors may be used to endorse or promote products derived from
// this software without specific prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
//
//
// Wrappers for primitive (non-message) types. These types are useful
// for embedding primitives in the `google.protobuf.Any` type and for places
// where we need to distinguish between the absence of a primitive
// typed field and its default value.
//
import { ScalarType } from "@protobuf-ts/runtime";
import { LongType } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime"; // @generated message type with reflection information, may provide speed optimized methods

var DoubleValue$Type = /*#__PURE__*/function (_MessageType) {
  _inherits(DoubleValue$Type, _MessageType);

  var _super = _createSuper(DoubleValue$Type);

  function DoubleValue$Type() {
    _classCallCheck(this, DoubleValue$Type);

    return _super.call(this, "google.protobuf.DoubleValue", [{
      no: 1,
      name: "value",
      kind: "scalar",
      T: 1
      /*ScalarType.DOUBLE*/

    }]);
  }
  /**
   * Encode `DoubleValue` to JSON number.
   */


  _createClass(DoubleValue$Type, [{
    key: "internalJsonWrite",
    value: function internalJsonWrite(message, options) {
      return this.refJsonWriter.scalar(2, message.value, "value", false, true);
    }
    /**
     * Decode `DoubleValue` from JSON number.
     */

  }, {
    key: "internalJsonRead",
    value: function internalJsonRead(json, options, target) {
      if (!target) target = this.create();
      target.value = this.refJsonReader.scalar(json, 1, undefined, "value");
      return target;
    }
  }, {
    key: "create",
    value: function create(value) {
      var message = {
        value: 0
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag = reader.tag(),
            _reader$tag2 = _slicedToArray(_reader$tag, 2),
            fieldNo = _reader$tag2[0],
            wireType = _reader$tag2[1];

        switch (fieldNo) {
          case
          /* double value */
          1:
            message.value = reader.double();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* double value = 1; */
      if (message.value !== 0) writer.tag(1, WireType.Bit64).double(message.value);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return DoubleValue$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message google.protobuf.DoubleValue
 */


export var DoubleValue = new DoubleValue$Type(); // @generated message type with reflection information, may provide speed optimized methods

var FloatValue$Type = /*#__PURE__*/function (_MessageType2) {
  _inherits(FloatValue$Type, _MessageType2);

  var _super2 = _createSuper(FloatValue$Type);

  function FloatValue$Type() {
    _classCallCheck(this, FloatValue$Type);

    return _super2.call(this, "google.protobuf.FloatValue", [{
      no: 1,
      name: "value",
      kind: "scalar",
      T: 2
      /*ScalarType.FLOAT*/

    }]);
  }
  /**
   * Encode `FloatValue` to JSON number.
   */


  _createClass(FloatValue$Type, [{
    key: "internalJsonWrite",
    value: function internalJsonWrite(message, options) {
      return this.refJsonWriter.scalar(1, message.value, "value", false, true);
    }
    /**
     * Decode `FloatValue` from JSON number.
     */

  }, {
    key: "internalJsonRead",
    value: function internalJsonRead(json, options, target) {
      if (!target) target = this.create();
      target.value = this.refJsonReader.scalar(json, 1, undefined, "value");
      return target;
    }
  }, {
    key: "create",
    value: function create(value) {
      var message = {
        value: 0
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag3 = reader.tag(),
            _reader$tag4 = _slicedToArray(_reader$tag3, 2),
            fieldNo = _reader$tag4[0],
            wireType = _reader$tag4[1];

        switch (fieldNo) {
          case
          /* float value */
          1:
            message.value = reader.float();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* float value = 1; */
      if (message.value !== 0) writer.tag(1, WireType.Bit32).float(message.value);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return FloatValue$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message google.protobuf.FloatValue
 */


export var FloatValue = new FloatValue$Type(); // @generated message type with reflection information, may provide speed optimized methods

var Int64Value$Type = /*#__PURE__*/function (_MessageType3) {
  _inherits(Int64Value$Type, _MessageType3);

  var _super3 = _createSuper(Int64Value$Type);

  function Int64Value$Type() {
    _classCallCheck(this, Int64Value$Type);

    return _super3.call(this, "google.protobuf.Int64Value", [{
      no: 1,
      name: "value",
      kind: "scalar",
      T: 3
      /*ScalarType.INT64*/

    }]);
  }
  /**
   * Encode `Int64Value` to JSON string.
   */


  _createClass(Int64Value$Type, [{
    key: "internalJsonWrite",
    value: function internalJsonWrite(message, options) {
      return this.refJsonWriter.scalar(ScalarType.INT64, message.value, "value", false, true);
    }
    /**
     * Decode `Int64Value` from JSON string.
     */

  }, {
    key: "internalJsonRead",
    value: function internalJsonRead(json, options, target) {
      if (!target) target = this.create();
      target.value = this.refJsonReader.scalar(json, ScalarType.INT64, LongType.STRING, "value");
      return target;
    }
  }, {
    key: "create",
    value: function create(value) {
      var message = {
        value: "0"
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag5 = reader.tag(),
            _reader$tag6 = _slicedToArray(_reader$tag5, 2),
            fieldNo = _reader$tag6[0],
            wireType = _reader$tag6[1];

        switch (fieldNo) {
          case
          /* int64 value */
          1:
            message.value = reader.int64().toString();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* int64 value = 1; */
      if (message.value !== "0") writer.tag(1, WireType.Varint).int64(message.value);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return Int64Value$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message google.protobuf.Int64Value
 */


export var Int64Value = new Int64Value$Type(); // @generated message type with reflection information, may provide speed optimized methods

var UInt64Value$Type = /*#__PURE__*/function (_MessageType4) {
  _inherits(UInt64Value$Type, _MessageType4);

  var _super4 = _createSuper(UInt64Value$Type);

  function UInt64Value$Type() {
    _classCallCheck(this, UInt64Value$Type);

    return _super4.call(this, "google.protobuf.UInt64Value", [{
      no: 1,
      name: "value",
      kind: "scalar",
      T: 4
      /*ScalarType.UINT64*/

    }]);
  }
  /**
   * Encode `UInt64Value` to JSON string.
   */


  _createClass(UInt64Value$Type, [{
    key: "internalJsonWrite",
    value: function internalJsonWrite(message, options) {
      return this.refJsonWriter.scalar(ScalarType.UINT64, message.value, "value", false, true);
    }
    /**
     * Decode `UInt64Value` from JSON string.
     */

  }, {
    key: "internalJsonRead",
    value: function internalJsonRead(json, options, target) {
      if (!target) target = this.create();
      target.value = this.refJsonReader.scalar(json, ScalarType.UINT64, LongType.STRING, "value");
      return target;
    }
  }, {
    key: "create",
    value: function create(value) {
      var message = {
        value: "0"
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag7 = reader.tag(),
            _reader$tag8 = _slicedToArray(_reader$tag7, 2),
            fieldNo = _reader$tag8[0],
            wireType = _reader$tag8[1];

        switch (fieldNo) {
          case
          /* uint64 value */
          1:
            message.value = reader.uint64().toString();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* uint64 value = 1; */
      if (message.value !== "0") writer.tag(1, WireType.Varint).uint64(message.value);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return UInt64Value$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message google.protobuf.UInt64Value
 */


export var UInt64Value = new UInt64Value$Type(); // @generated message type with reflection information, may provide speed optimized methods

var Int32Value$Type = /*#__PURE__*/function (_MessageType5) {
  _inherits(Int32Value$Type, _MessageType5);

  var _super5 = _createSuper(Int32Value$Type);

  function Int32Value$Type() {
    _classCallCheck(this, Int32Value$Type);

    return _super5.call(this, "google.protobuf.Int32Value", [{
      no: 1,
      name: "value",
      kind: "scalar",
      T: 5
      /*ScalarType.INT32*/

    }]);
  }
  /**
   * Encode `Int32Value` to JSON string.
   */


  _createClass(Int32Value$Type, [{
    key: "internalJsonWrite",
    value: function internalJsonWrite(message, options) {
      return this.refJsonWriter.scalar(5, message.value, "value", false, true);
    }
    /**
     * Decode `Int32Value` from JSON string.
     */

  }, {
    key: "internalJsonRead",
    value: function internalJsonRead(json, options, target) {
      if (!target) target = this.create();
      target.value = this.refJsonReader.scalar(json, 5, undefined, "value");
      return target;
    }
  }, {
    key: "create",
    value: function create(value) {
      var message = {
        value: 0
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag9 = reader.tag(),
            _reader$tag10 = _slicedToArray(_reader$tag9, 2),
            fieldNo = _reader$tag10[0],
            wireType = _reader$tag10[1];

        switch (fieldNo) {
          case
          /* int32 value */
          1:
            message.value = reader.int32();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* int32 value = 1; */
      if (message.value !== 0) writer.tag(1, WireType.Varint).int32(message.value);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return Int32Value$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message google.protobuf.Int32Value
 */


export var Int32Value = new Int32Value$Type(); // @generated message type with reflection information, may provide speed optimized methods

var UInt32Value$Type = /*#__PURE__*/function (_MessageType6) {
  _inherits(UInt32Value$Type, _MessageType6);

  var _super6 = _createSuper(UInt32Value$Type);

  function UInt32Value$Type() {
    _classCallCheck(this, UInt32Value$Type);

    return _super6.call(this, "google.protobuf.UInt32Value", [{
      no: 1,
      name: "value",
      kind: "scalar",
      T: 13
      /*ScalarType.UINT32*/

    }]);
  }
  /**
   * Encode `UInt32Value` to JSON string.
   */


  _createClass(UInt32Value$Type, [{
    key: "internalJsonWrite",
    value: function internalJsonWrite(message, options) {
      return this.refJsonWriter.scalar(13, message.value, "value", false, true);
    }
    /**
     * Decode `UInt32Value` from JSON string.
     */

  }, {
    key: "internalJsonRead",
    value: function internalJsonRead(json, options, target) {
      if (!target) target = this.create();
      target.value = this.refJsonReader.scalar(json, 13, undefined, "value");
      return target;
    }
  }, {
    key: "create",
    value: function create(value) {
      var message = {
        value: 0
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag11 = reader.tag(),
            _reader$tag12 = _slicedToArray(_reader$tag11, 2),
            fieldNo = _reader$tag12[0],
            wireType = _reader$tag12[1];

        switch (fieldNo) {
          case
          /* uint32 value */
          1:
            message.value = reader.uint32();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* uint32 value = 1; */
      if (message.value !== 0) writer.tag(1, WireType.Varint).uint32(message.value);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return UInt32Value$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message google.protobuf.UInt32Value
 */


export var UInt32Value = new UInt32Value$Type(); // @generated message type with reflection information, may provide speed optimized methods

var BoolValue$Type = /*#__PURE__*/function (_MessageType7) {
  _inherits(BoolValue$Type, _MessageType7);

  var _super7 = _createSuper(BoolValue$Type);

  function BoolValue$Type() {
    _classCallCheck(this, BoolValue$Type);

    return _super7.call(this, "google.protobuf.BoolValue", [{
      no: 1,
      name: "value",
      kind: "scalar",
      T: 8
      /*ScalarType.BOOL*/

    }]);
  }
  /**
   * Encode `BoolValue` to JSON bool.
   */


  _createClass(BoolValue$Type, [{
    key: "internalJsonWrite",
    value: function internalJsonWrite(message, options) {
      return message.value;
    }
    /**
     * Decode `BoolValue` from JSON bool.
     */

  }, {
    key: "internalJsonRead",
    value: function internalJsonRead(json, options, target) {
      if (!target) target = this.create();
      target.value = this.refJsonReader.scalar(json, 8, undefined, "value");
      return target;
    }
  }, {
    key: "create",
    value: function create(value) {
      var message = {
        value: false
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag13 = reader.tag(),
            _reader$tag14 = _slicedToArray(_reader$tag13, 2),
            fieldNo = _reader$tag14[0],
            wireType = _reader$tag14[1];

        switch (fieldNo) {
          case
          /* bool value */
          1:
            message.value = reader.bool();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* bool value = 1; */
      if (message.value !== false) writer.tag(1, WireType.Varint).bool(message.value);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return BoolValue$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message google.protobuf.BoolValue
 */


export var BoolValue = new BoolValue$Type(); // @generated message type with reflection information, may provide speed optimized methods

var StringValue$Type = /*#__PURE__*/function (_MessageType8) {
  _inherits(StringValue$Type, _MessageType8);

  var _super8 = _createSuper(StringValue$Type);

  function StringValue$Type() {
    _classCallCheck(this, StringValue$Type);

    return _super8.call(this, "google.protobuf.StringValue", [{
      no: 1,
      name: "value",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }
  /**
   * Encode `StringValue` to JSON string.
   */


  _createClass(StringValue$Type, [{
    key: "internalJsonWrite",
    value: function internalJsonWrite(message, options) {
      return message.value;
    }
    /**
     * Decode `StringValue` from JSON string.
     */

  }, {
    key: "internalJsonRead",
    value: function internalJsonRead(json, options, target) {
      if (!target) target = this.create();
      target.value = this.refJsonReader.scalar(json, 9, undefined, "value");
      return target;
    }
  }, {
    key: "create",
    value: function create(value) {
      var message = {
        value: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag15 = reader.tag(),
            _reader$tag16 = _slicedToArray(_reader$tag15, 2),
            fieldNo = _reader$tag16[0],
            wireType = _reader$tag16[1];

        switch (fieldNo) {
          case
          /* string value */
          1:
            message.value = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string value = 1; */
      if (message.value !== "") writer.tag(1, WireType.LengthDelimited).string(message.value);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return StringValue$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message google.protobuf.StringValue
 */


export var StringValue = new StringValue$Type(); // @generated message type with reflection information, may provide speed optimized methods

var BytesValue$Type = /*#__PURE__*/function (_MessageType9) {
  _inherits(BytesValue$Type, _MessageType9);

  var _super9 = _createSuper(BytesValue$Type);

  function BytesValue$Type() {
    _classCallCheck(this, BytesValue$Type);

    return _super9.call(this, "google.protobuf.BytesValue", [{
      no: 1,
      name: "value",
      kind: "scalar",
      T: 12
      /*ScalarType.BYTES*/

    }]);
  }
  /**
   * Encode `BytesValue` to JSON string.
   */


  _createClass(BytesValue$Type, [{
    key: "internalJsonWrite",
    value: function internalJsonWrite(message, options) {
      return this.refJsonWriter.scalar(12, message.value, "value", false, true);
    }
    /**
     * Decode `BytesValue` from JSON string.
     */

  }, {
    key: "internalJsonRead",
    value: function internalJsonRead(json, options, target) {
      if (!target) target = this.create();
      target.value = this.refJsonReader.scalar(json, 12, undefined, "value");
      return target;
    }
  }, {
    key: "create",
    value: function create(value) {
      var message = {
        value: new Uint8Array(0)
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag17 = reader.tag(),
            _reader$tag18 = _slicedToArray(_reader$tag17, 2),
            fieldNo = _reader$tag18[0],
            wireType = _reader$tag18[1];

        switch (fieldNo) {
          case
          /* bytes value */
          1:
            message.value = reader.bytes();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* bytes value = 1; */
      if (message.value.length) writer.tag(1, WireType.LengthDelimited).bytes(message.value);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return BytesValue$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message google.protobuf.BytesValue
 */


export var BytesValue = new BytesValue$Type();